import { FunctionComponent } from 'react'
import styles from './newsDraftHandler.module.scss'
import { useAuth } from '@/modules/context/AuthContext'
import { Navigate, NavigateFunction, useNavigate } from 'react-router-dom'
import DaycareSelector from '@/components/DaycareSelector/daycareSelector.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { ArrowBack } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import NewsDraftFeed from './newsDraftFeed'

const NewsDraftHandler: FunctionComponent = () => {
    const { t } = useTranslation()

    const { user, device } = useAuth()

    const navigate: NavigateFunction = useNavigate()

    return (
        <div className={styles.PagePosition}>
            {user?.role &&
            user.currentDaycare &&
            user.currentDaycareRights &&
            user.currentDaycareRights.hasNewsAccess ? (
                <>
                    {user && user?.daycares.length > 1 && (
                        <div className={styles.HeaderRow}>
                            <div className={styles.MultipleSections}>
                                <DaycareSelector />
                            </div>
                            <ButtonTextIcon
                                type={'custom'}
                                customIcon={<ArrowBack />}
                                customText={t('returnToNews')}
                                onClick={() => navigate('/news')}
                                className={styles.Button}
                            />
                        </div>
                    )}
                    <NewsDraftFeed
                        role={user.role}
                        canUpdate={user.currentDaycareRights.canWriteNewsFeed}
                        canValidPosts={user.currentDaycareRights.canAddNewsWithoutValidation}
                        daycare={user.currentDaycare}
                        isApplication={device?.platform !== 'web'}
                    />
                    {user && user.daycares.length === 1 && (
                        <ButtonTextIcon
                            type={'custom'}
                            customIcon={<ArrowBack />}
                            customText={t('returnToNews')}
                            onClick={() => navigate('/news')}
                        />
                    )}
                </>
            ) : (
                <Navigate to='/' replace />
            )}
        </div>
    )
}

export default NewsDraftHandler
